import { Component, ErrorHandler, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy, signal } from '@angular/core'
import { form } from '@angular/forms/signals'

import { KirjanpitajanRooli } from '@lemon/core-firebase/lemonator/model/kirjanpitaja'
import { AuthProviderName, SsoLoginService } from 'app/_angular/service/sso-login-service'
import { LadataanService } from 'app/_jaettu-angular/service/ladataan.service'
import { KirjautunutKayttajaService } from '../_angular/service/kirjautunut-kayttaja.service'

@Component({
  selector: 'app-sso-login',
  templateUrl: './sso-login.component.html',
  styleUrls: ['./sso-login.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SsoLoginComponent implements OnInit {
  @Output() cancel = new EventEmitter<void>()
  @Input() autoStart: boolean = false

  readonly kirjautuminenKaynnissa = signal(false)
  readonly useammanTilinLinkitysKaynnissa = signal(false)
  readonly roolinValintaKaynnissa = signal(false)
  readonly commonError = signal<string | null>(null)

  roolit: { nimi: string; arvo: KirjanpitajanRooli }[] = [
    { nimi: 'Super-admin', arvo: KirjanpitajanRooli.SUPER },
    { nimi: 'Tavallinen kirjanpitäjä', arvo: KirjanpitajanRooli.TAVALLINEN },
    { nimi: 'Tavallinen kirjanpitäjä ja Holvi', arvo: KirjanpitajanRooli.TAVALLINEN_JA_HOLVI },
  ]
  valittuRooli: { nimi: string; arvo: KirjanpitajanRooli } = this.roolit[0]
  tilintarkastajaAvain = form(signal(''))

  constructor(
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _ladataanService: LadataanService,
    private _errorHandler: ErrorHandler,
    private _ssoLoginService: SsoLoginService,
  ) {}

  ngOnInit(): void {
    this._kirjautunutKayttajaService.asetakirjanpitajanulliksi(true)
    // Jos autoStart päällä, ei näytetä tunnistautumisvaihtoehtoja
    if (this.autoStart) {
      this.kirjauduProviderilla('microsoft')
    }
  }

  kirjauduProviderilla(providerName: AuthProviderName) {
    this._kirjauduProviderilla(providerName)
  }

  kirjaudu() {
    const rooli = this.valittuRooli.arvo
    const tilintarkastajaAvain = this.tilintarkastajaAvain().value().trim() || null
    this._kirjauduCustom(rooli, tilintarkastajaAvain)
  }

  onCancel() {
    if (!this.kirjautuminenKaynnissa()) {
      this.cancel.emit()
    }
  }

  private async _kirjauduProviderilla(providerName: AuthProviderName) {
    this.commonError.set(null)
    this.kirjautuminenKaynnissa.set(true)
    this._ladataanService.aloitaLataaminen()
    try {
      const result = await this._ssoLoginService.kirjauduProviderilla(providerName)
      if (result && result.linkitys) {
        this.useammanTilinLinkitysKaynnissa.set(true)
        this.kirjautuminenKaynnissa.set(false)
        this._ladataanService.lopetaLataaminen()
        return
      }
      if (result && result.rooliValinta) {
        this.roolinValintaKaynnissa.set(true)
        this.kirjautuminenKaynnissa.set(false)
        this._ladataanService.lopetaLataaminen()
        return
      }
      await this._kirjauduCustom(undefined)
    } catch (error) {
      this.commonError.set('Kirjautumisen aikana tapahtui virhe. Ilmoita tästä ylläpidolle.')
      this._errorHandler.handleError(error)
      this.kirjautuminenKaynnissa.set(false)
      this.onCancel()
      this._ladataanService.lopetaLataaminen()
    }
  }

  private async _kirjauduCustom(rooli?: KirjanpitajanRooli, tilintarkastajaAvain?: string) {
    this.commonError.set(null)
    this.kirjautuminenKaynnissa.set(true)
    this._ladataanService.aloitaLataaminen()
    try {
      await this._ssoLoginService.kirjauduCustom(rooli, tilintarkastajaAvain)
      this._ladataanService.lopetaLataaminen()
      window.location.href = tilintarkastajaAvain ? '/tilintarkastajat/aloitus' : '/'
    } catch (error) {
      this.commonError.set('Kirjautumisen aikana tapahtui virhe. Ilmoita tästä ylläpidolle.')
      this._errorHandler.handleError(error)
      this.kirjautuminenKaynnissa.set(false)
      this.onCancel()
      this._ladataanService.lopetaLataaminen()
    }
  }
}
